import React from 'react';
import styled from 'styled-components';
import { AxlMultiSelect } from 'axl-reactjs-ui';
import { lightTheme } from '../../themes';

const Wrapper = styled.div`
    & button{
        color: ${lightTheme.palette.primary.main};
        border-color: ${lightTheme.palette.primary.main};
    }
    & span.checked {
        border-color: ${lightTheme.palette.primary.main};
    }    
`;

const StyledAxlMultiSelect = (props) => (
    <Wrapper>
        <AxlMultiSelect {...props} />
    </Wrapper>
);

export default StyledAxlMultiSelect;